import { useSelector } from 'react-redux';

export const useFeatureAvailable = (featureName) => {
  const features = useSelector(state => state.company?.features?.data || []);
  return features.some(
    f => f.feature === featureName && f.is_active
  );
};
